import axios, { AxiosInstance } from "axios";
import AppConfig from "../../AppConfig";
export const axiosInstance: AxiosInstance = axios.create({
    baseURL: AppConfig.url,
    headers: {
        Accept: "application/json",
    },
});

export default axiosInstance;
